let timelineElements = [
    {
      id: 1,
      title: "Full Stack Developer",
      title2: "RUF Company",
      location: "Rivne, Ukraine",
      description:
        "Full-stack development, improvement and maintenance of company’s software (increased website speed on 40% and new design brought 30% more clients)",
      buttonText: "View Portfolio",
      date: "August 2018 - July 2019",
      icon: "work"
    },    

    {
      id: 2,
      title: "Computer Lab Assistant",
      title2: "IT Step Academy",
      location: "Lviv, Ukraine",
      description:
        "Maintenance of the company’s personal software and hardware.",
      buttonText: "View Portfolio",
      date: "November 2017 - June 2018",
      icon: "work"
    }
  ];
  
  export default timelineElements;
  